
import React from 'react'
import Link from 'gatsby-link'
import get from 'lodash/get'
import Seo from '../components/Seo'
import Nav from '../components/Nav'
import Bio from '../components/Bio/Bio'
import { rhythm } from '../utils/typography'

class BlogListing extends React.Component {
    render() {
        //const siteTitle = get(this, 'props.data.site.siteMetadata.title')
        const moment = require("moment")
        const now = moment(new Date());
        const posts = get(this, 'props.data.allMarkdownRemark.edges')
        const config = require('../../content/meta/config')
        const { data } = this.props
        //const facebook = (((data || {}).site || {}).siteMetadata || {}).facebook
        const { totalCount } = data.allMarkdownRemark
        const postsCountHeader = `${totalCount} post${totalCount === 1 ? '' : 's'}`
        const d = {
            title: 'All posts at ' + config.shortSiteTitle,
            description: 'All posts at ' + config.shortSiteTitle,
            image: config.siteImage,
            url: config.siteUrl + '/blog',
            keywords: config.resumeKeywords,
            datePublished: "2018-07-01",
            dateUpdated: now.format("YYYY-MM-DD")
        }
        return (
            <div>
                <Seo data={d} pageType='listing' />
                <Nav />
                <Bio articleCount={postsCountHeader} />
                {/* <div style={{
          marginBottom: rhythm(0.1)
        }}>{config.authorShortName} has written {postsCountHeader}.</div> */}

                {posts.map(({ node }) => {
                    const title = get(node, 'frontmatter.title') || node.fields.slug
                    //console.log(title)
                    const tags = node.frontmatter.tags || []
                    return (
                        <div key={node.fields.slug} style={{
                            // border: 'solid 1px red',
                            // borderRadius: '50',
                            // paddingLeft: rhythm(0.5),
                            // margin: rhythm(0.5),
                        }}>
                            <h3
                                style={{
                                    marginBottom: rhythm(1 / 4),
                                }}
                            >
                                <Link style={{ boxShadow: 'none' }} to={node.fields.slug}>
                                    {title}
                                </Link>
                            </h3>
                            {tags.map((tag, index) => {
                                return (
                                    <span
                                        style={{
                                            margin: '0px 12px 0px 0px',
                                            paddingLeft: '4px',
                                            //border: '1px solid rebeccapurple',
                                        }}
                                        key={index}
                                        className="tag"
                                    >
                                        <Link
                                            to={`/tags/${tag}`}
                                            style={{
                                                color: 'rebeccapurple',
                                                textDecoration: 'none',
                                            }}
                                        >
                                            {tag}
                                        </Link>{' '}
                                    </span>
                                )
                            })}
                            <small>{node.frontmatter.date}</small>
                            <p dangerouslySetInnerHTML={{ __html: node.excerpt }} />
                        </div>
                    )
                })}
            </div>
        )
    }
}

export default BlogListing

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        facebook {
          appId
        }
      }
    }
    allMarkdownRemark(
      filter: { id: { regex: "//posts//" } }
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      totalCount
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            tags
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.js